import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class InteractionService {
  static ENDPOINT = `${BASE}/interaction`;

  static async getAll() {
    return await request({
      url: `${this.ENDPOINT}/`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async get(id) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      headers: {'Accept': 'application/json'}
    })
  }

  static async update(id, interactionUpdate) {
    return await request({
      url: `${this.ENDPOINT}/${encodeURIComponent(id)}`,
      method: 'PUT',
      body: interactionUpdate
    })
  }
}

export default InteractionService;
